<script>
import {_} from 'svelte-i18n';
import HTMLContent from './../../custom/HTMLContent/HTMLContent.svelte';
import Doc from '../../custom/Doc.svelte';
import { getVideo, api } from '../../../helpers';
import ImagePopup from '../../custom/ImagePopup.svelte';

    import { post } from './store';
    import { info_client, list } from '../../stores';
    import ToggleVideoButton from '../../custom/ToggleVideoButton.svelte';
    import { scrolledPublicationId } from '../Newsline/store';

export let text;
export let image;
export let video_url;
export let video_url_2;
export let video_domain;
export let video_domain_2;
export let audio_url;
export let doc;
export let id
export let id_publicate
export let is_view
export let videoCount;
export let is_show_view_button;

const youtubeVideoKey = 'youtube';
const kinescopeVideoKey = 'kinescope';

let videoType = video_domain ? youtubeVideoKey : kinescopeVideoKey;
let showModalPictere = false;
let controller = new AbortController()
let signal = controller.signal

const viewPublication = async () => {
  const urlMethod = is_view ? 'delete' : 'create'
  const method = is_view ? 'DELETE' : 'POST'
  const url = `/api/v1/view-publication-item/${urlMethod}/${id}/`

  controller.abort()
  controller = new AbortController()
  signal = controller.signal

  await api(url, method, {}, false, signal)

  is_view = !is_view;

  const item = $post.publication_items.find((item) => item.id === id);
  const video = $post.videos.find((video) => video.pk === id);

  item.is_view = !item.is_view;
  video.is_view = !video.is_view;

  $post.i_view = $post.publication_items.filter((item) => item.is_view).length / $post.videos.length * 100;

  $list = $list;
}

</script>
<div class='main__item'>
  {#if video_url !== '' || video_domain_2}
    <div class="flex items-center gap-2">
      {#if video_domain}
        <ToggleVideoButton 
          label={youtubeVideoKey}
          isActive={videoType === youtubeVideoKey}
          on:toggle={() => videoType = youtubeVideoKey}
        />
      {/if}

      {#if video_domain_2}
        <ToggleVideoButton 
          label={kinescopeVideoKey}
          isActive={videoType === kinescopeVideoKey}
          on:toggle={() => videoType = kinescopeVideoKey}
        />
      {/if}
    </div>

    {#if video_domain !== null || video_domain_2 !== null}
      <div class='video' data-item-id={id} data-publ-id={id_publicate}>
        <iframe src="{videoType === kinescopeVideoKey ? video_url_2 : getVideo(video_domain, video_url)}"
          referrerpolicy="strict-origin-when-cross-origin"
          allow='autoplay'
          title allowfullscreen
          loading='lazy'>
        </iframe>
      </div>
    {/if}
  {/if}

  {#if audio_url !== ''}
    <span class='audio' data-item-id={id} data-publ-id={id_publicate}>
      {@html audio_url}
    </span>
  {/if}

  {#if doc !== null}
    <Doc {id} {id_publicate} {doc} />
  {/if}

  {#if videoCount > 1 && (video_url || video_domain_2) && !$info_client.is_staff && is_show_view_button}
    <div class="py-3 flex justify-end w-full">
      <button 
        type="button"
        class="view-button"
        class:active={is_view}
        on:click={viewPublication}
      >
        {#if is_view}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3462 7.7602C13.0538 4.9462 10.6227 3.2002 7.99961 3.2002C5.37652 3.2002 2.94537 4.9462 1.65302 7.7602C1.61779 7.8359 1.59961 7.9176 1.59961 8.0002C1.59961 8.08279 1.61779 8.1645 1.65302 8.2402C2.94537 11.0542 5.37652 12.8002 7.99961 12.8002C10.6227 12.8002 13.0538 11.0542 14.3462 8.2402C14.3814 8.1645 14.3996 8.08279 14.3996 8.0002C14.3996 7.9176 14.3814 7.8359 14.3462 7.7602ZM6.57785 6.00467C6.99869 5.74095 7.49347 5.6002 7.99961 5.6002C8.67833 5.6002 9.32925 5.85305 9.80918 6.30314C10.2891 6.75323 10.5587 7.36368 10.5587 8.0002C10.5587 8.47487 10.4086 8.93889 10.1274 9.33356C9.84624 9.72824 9.44656 10.0359 8.97894 10.2175C8.51133 10.3992 7.99677 10.4467 7.50036 10.3541C7.00394 10.2615 6.54795 10.0329 6.19005 9.69725C5.83215 9.36161 5.58842 8.93397 5.48968 8.46841C5.39093 8.00286 5.44161 7.5203 5.6353 7.08176C5.829 6.64321 6.15701 6.26838 6.57785 6.00467ZM7.99962 9.2002C7.74655 9.2002 7.49916 9.12982 7.28874 8.99796C7.07832 8.8661 6.91432 8.67869 6.81747 8.45942C6.72062 8.24014 6.69528 7.99887 6.74466 7.76609C6.79403 7.53331 6.91589 7.31949 7.09484 7.15167C7.27379 6.98385 7.50179 6.86956 7.74999 6.82325C7.9982 6.77695 8.25548 6.80072 8.48929 6.89154C8.72309 6.98237 8.92293 7.13617 9.06353 7.33351C9.20413 7.53085 9.27918 7.76286 9.27918 8.0002C9.27918 8.31846 9.14437 8.62368 8.9044 8.84872C8.66444 9.07377 8.33898 9.2002 7.99962 9.2002Z" fill="#2B50ED"/>
          </svg>
        {:else}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4564 7.97516L13.2632 7.19998L14.4564 6.42479L15 7.19997L14.4564 7.97516ZM2.73677 7.19998C1.54363 7.97516 1.54394 7.97561 1.54426 7.97606L1.54494 7.97703L1.54644 7.97916L1.55001 7.98421L1.55944 7.99737C1.56673 8.0075 1.57604 8.0203 1.58737 8.03559C1.61 8.06617 1.64071 8.1068 1.67935 8.15604C1.75653 8.25438 1.86595 8.38785 2.00649 8.54469C2.28617 8.8568 2.69682 9.27014 3.23006 9.68489C4.28671 10.5067 5.91326 11.4 8.00003 11.4C10.0868 11.4 11.7133 10.5067 12.7699 9.68488C13.3032 9.27013 13.7138 8.8568 13.9935 8.54468C14.134 8.38785 14.2435 8.25438 14.3206 8.15604C14.3593 8.1068 14.39 8.06617 14.4126 8.03559C14.4239 8.0203 14.4333 8.0075 14.4406 7.99737L14.45 7.98421L14.4535 7.97916L14.4557 7.97606C14.456 7.97561 14.4564 7.97516 13.2632 7.19998C14.4564 6.42479 14.456 6.42434 14.4557 6.42389L14.4535 6.42079L14.45 6.41574L14.4405 6.40258C14.4333 6.39245 14.4239 6.37965 14.4126 6.36436C14.39 6.33378 14.3593 6.29315 14.3206 6.24392C14.2435 6.14557 14.134 6.01211 13.9935 5.85527C13.7138 5.54316 13.3032 5.12983 12.7699 4.71509C11.7133 3.89324 10.0868 3 8.00003 3C5.91326 3 4.28672 3.89323 3.23006 4.71508C2.69683 5.12983 2.28618 5.54316 2.0065 5.85527C1.86596 6.0121 1.75653 6.14557 1.67935 6.24391C1.64072 6.29315 1.61001 6.33378 1.58737 6.36436C1.57605 6.37965 1.56673 6.39245 1.55944 6.40258L1.55002 6.41574L1.54644 6.42079L1.54494 6.42292L1.54426 6.42389C1.54394 6.42434 1.54363 6.42479 2.73677 7.19998ZM2.73677 7.19998L1.54363 7.97516L1 7.19997L1.54363 6.42479L2.73677 7.19998ZM2.73677 7.19998C2.73677 7.19998 4.71049 4.38557 8.00003 4.38557C11.2895 4.38557 13.2632 7.19998 13.2632 7.19998C13.2632 7.19998 11.2895 10.0144 8.00003 10.0144C4.71049 10.0144 2.73677 7.19998 2.73677 7.19998Z" fill="#BDBFC4"/>
            <path d="M7.4748 11.2248C7.4748 10.9107 7.72943 10.656 8.04355 10.656C8.35766 10.656 8.6123 10.9107 8.6123 11.2248V13.281C8.6123 13.5951 8.35766 13.8498 8.04355 13.8498C7.72943 13.8498 7.4748 13.5951 7.4748 13.281V11.2248Z" fill="#BDBFC4"/>
            <path d="M4.99166 10.4478C5.14871 10.1758 5.49656 10.0826 5.76858 10.2397C6.04061 10.3967 6.13382 10.7446 5.97676 11.0166L4.92646 12.5625C4.7694 12.8345 4.42156 12.9278 4.14953 12.7707C3.8775 12.6136 3.7843 12.2658 3.94136 11.9938L4.99166 10.4478Z" fill="#BDBFC4"/>
            <path d="M2.43751 8.36172C2.61768 8.10441 2.97232 8.04188 3.22962 8.22205C3.48693 8.40221 3.54946 8.75686 3.36929 9.01416L2.49172 10.1263C2.31155 10.3836 1.95691 10.4461 1.69961 10.2659C1.4423 10.0858 1.37977 9.73113 1.55994 9.47383L2.43751 8.36172Z" fill="#BDBFC4"/>
            <path d="M11.0956 10.4478C10.9385 10.1758 10.5907 10.0826 10.3187 10.2397C10.0466 10.3967 9.95342 10.7446 10.1105 11.0166L11.1898 12.5916C11.3469 12.8636 11.6947 12.9568 11.9668 12.7998C12.2388 12.6427 12.332 12.2949 12.1749 12.0228L11.0956 10.4478Z" fill="#BDBFC4"/>
            <path d="M13.6496 8.36172C13.4694 8.10441 13.1148 8.04188 12.8575 8.22205C12.6002 8.40221 12.5376 8.75686 12.7178 9.01416L13.5074 10.0382C13.6876 10.2955 14.0422 10.358 14.2995 10.1778C14.5568 9.99767 14.6194 9.64303 14.4392 9.38572L13.6496 8.36172Z" fill="#BDBFC4"/>
          </svg>
        {/if}
        
        {is_view ? $_('viewed') : $_('notViewed')}
      </button>
    </div>
  {/if}

  {#if image}
    <div class="image">
      <img
        src={image}
        alt
        on:click="{() => showModalPictere = true}"
      >
    </div>

    <!-- модальное окно для картинки -->
    <ImagePopup 
      isShow={showModalPictere}
      src={image}
      currentImageIndex={0}
      imagesCount={1}
      on:close="{() => showModalPictere = false}"
    />
  {/if}

  {#if text !== ''}
    <HTMLContent value={text} />
  {/if}
</div>


<style lang="scss">
  .view-button {
    background: #F3F3F4;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #5A5F6D99;
    padding: 5px 10px;
    border-radius: 30px;
    border: none;
    display: flex;
    align-items: center;
    grid-gap: 4px;

    &.active {
      background: #EFF1FD;
      color: #2B50ED;
    }
  }

.main__item{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
}

.url{
  text-decoration: none;
  font-size: 16px;
  line-height: 28px;
  color: #2B50ED;
}

.video {
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
  padding-right: 100%;
  margin: 16px 0;
}

.video iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 10px;
}

.audio{
  padding: 6px 0 7px 0;
  width: 100%;
}

.image{
  margin-bottom: 14px;
  width: 100%;
  height: 100%;
  display: inline-block;
  cursor: pointer;
  // Убираем выделение при нажатии в моб-ых версиях
  -webkit-tap-highlight-color: transparent;
}

img{
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

@media (max-width: 500px){
  .url{
    text-decoration: none;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
